module.exports = __webpack_public_path__ + "img/image-3.5a594e3d.png";